import React, { useEffect, useState } from 'react';

const formatDate = (date: Date) =>
  date.toLocaleDateString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

const formatTime = (date: Date, options?: Intl.DateTimeFormatOptions) =>
  date.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    ...options,
  });

const ClockWidget: React.FC = () => {
  const [now, setNow] = useState<Date>(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="terminal-panel flex flex-col justify-between rounded-2xl border border-slate-800/80 p-4 text-xs text-slate-200">
      <div className="flex items-center justify-between">
        <span className="text-[11px] uppercase tracking-[0.2em] text-slate-400">Time</span>
        <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 shadow-[0_0_12px_rgba(52,211,153,0.8)]" />
      </div>
      <div className="mt-4 space-y-1">
        <div className="text-lg font-semibold tracking-tight text-slate-50">{formatTime(now)}</div>
        <div className="text-[11px] uppercase tracking-[0.16em] text-slate-400">{formatDate(now)}</div>
      </div>
      <div className="mt-4 grid gap-2 border-t border-slate-800/80 pt-3 text-[11px] text-slate-300">
        <div className="flex items-baseline justify-between">
          <span className="text-slate-500">Local time</span>
          <span>{formatTime(now, { hour12: false })}</span>
        </div>
        <div className="flex items-baseline justify-between">
          <span className="text-slate-500">UTC</span>
          <span>{now.toUTCString().slice(17, 25)}</span>
        </div>
      </div>
    </div>
  );
};

export default ClockWidget;

